import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/Contact.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to a server
    console.log('Form submitted');
    // Reset form after submission
  };

  return (
    <>
      <Container className="contact-container">
        <br></br> <br></br>   <br></br>  <br></br>
        <section id="faq" className="faq section-bg">
          <div className="container" data-aos="fade-up">
            <div className="faq-title text-center">
              <h2>Frequently Asked Questions</h2>
            </div>

            <div className="row d-flex align-items-stretch">
              <div className="col-lg-6 faq-item" data-aos="fade-up">
                <h4>Je, mfumo wa kupanga harusi mtandaoni ni nini?</h4>
                <p>
                  Mfumo wa kuratibu shughuli yako mtandaoni ni chombo cha kidijitali kinachokusaidia kupanga na kusimamia kila kipengele cha shughuli yako kirahisi sana, kuanzia kuwajulisha watu kuhusu shughuli yako, kurekodi ahadi za watu wako, kukumbushia michango hadi kufuatilia bajeti ya shughuli yako ili kurahisisha ufuatiliaji wa kamati.                </p>
              </div>
              <div className="col-lg-6 faq-item" data-aos="fade-up" data-aos-delay="100">
                <h4>Unavyofanya kazi?</h4>
                <p>
                  Ni rahisi tu baada ya kuinstall application yako, unda akaunti yako yenye maelezo ya shughuli yako, na anza kuratibu shughuli yako kiganjani kwako.                </p>
              </div>
              <div className="col-lg-6 faq-item" data-aos="fade-up" data-aos-delay="100">
                <h4>Je, ni rahisi kutumia?</h4>
                <p>
                  Ndiyo, mfumo wetu umetengenezwa kusaidia na kurahisisha uratibu wa shughuli kuwa mrahisi sana kwa kila mtu, hata kwa wale ambao si wajuzi wa teknolojia wanaweza kuutumia mfumo wetu.                </p>
              </div>
              <div className="col-lg-6 faq-item" data-aos="fade-up" data-aos-delay="100">
                <h4>Je, naweza kutengeneza mwaliko wa kidijitali?</h4>
                <p>
                  Bila shaka! Mfumo wetu unakuwezesha kuchagua muundo na aina ya kadi uipendayo kwa kutumia simu yako na kusambaza kwa wageni wako kwa hatua rahisi.                </p>
              </div>
              <div className="col-lg-6 faq-item" data-aos="fade-up" data-aos-delay="100">
                <h4>Je, kipengele cha kuongeza wageni kinafanyaje kazi? </h4>
                <p>
                  Unaweza kuongeza wageni kirahisi kwa kupakia majina kutoka kwenye phonebook list yako au kupandisha excel.                </p>
              </div>
              <div className="col-lg-6 faq-item" data-aos="fade-up" data-aos-delay="100">
                <h4>Je, kuna kipengele cha kupata watoa huduma?</h4>
                <p>
                  Tunakukutanisha na watoa huduma mbalimbali mfano ukumbi, keki, chakula kutoka maeneo yote nchi nzima ikiwa ni pamoja na package zao, hivo utachagua mtoa huduma aliyekaribu na eneo lako na kufanya mawasiliano naye.Tunafanya vyote ili kuhakikisha tunakuokolea muda na gharama za usafiri.                </p>
              </div>
              {/* Ongeza maswali ya ziada ya FAQ hapa */}
            </div>




          </div>
        </section>

        <section id="contact" className="contact">
          <div className="container" data-aos="fade-up">
            <div className="contact-title">
              <h2>Contact Us</h2>
            </div>

            <div className="row">
              <div className="col-lg-6 d-flex" data-aos="fade-up">
                <div className="info-box">
                  <i className="bi bi-geo-alt"></i>
                  <h3>Our Address</h3>
                  <p>3rd Floor, Room No 417 New Safari Hotel Business Centre, Arusha, Tanzania </p>
                </div>
              </div>
              <div className="col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="100">
                <div className="info-box">
                  <i className="bi bi-envelope"></i>
                  <h3>Email Us</h3>
                  <p><a href="mailto:harusidotonline@gmail.com">harusidotonline@gmail.com</a></p>
                </div>
              </div>
              <div className="col-lg-3 d-flex" data-aos="fade-up" data-aos-delay="200">
                <div className="info-box">
                  <i className="bi bi-telephone"></i>
                  <h3>Call Us</h3>
                  <p><a href="tel:+255747636516">+255 747 636 516</a><br /><a href="tel:+255717392442">+255 717 392 442</a></p>
                </div>
              </div>
              <div className="col-lg-12" data-aos="fade-up" data-aos-delay="300">
                <form onSubmit={handleSubmit} className="php-email-form">
                  <div className="row">
                    <div className="col-lg-6 form-group">
                      <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required />
                    </div>
                    <div className="col-lg-6 form-group">
                      <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required />
                  </div>
                  <div className="form-group">
                    <textarea className="form-control" name="message" rows="5" placeholder="Message" required></textarea>
                  </div>
                  <div className="my-3">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">Your message has been sent. Thank you!</div>
                  </div>
                  <div className="text-center"><button type="submit">Send Message</button></div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <br></br>
        <br></br>
      </Container>
    </>
  );
};

export default Contact;